import './../public/style.css'; // Importa el CSS global
import { router } from './app'; // Eliminado .js
import { authService } from './services/authService'; // Eliminado .js

// Función para inicializar la aplicación
function initializeApp() {
    // Si no hay token o usuario en localStorage, redirigir al login
    if (!authService.isAuthenticated()) {
        router.navigate('/login');
    } else {
        // Si hay token y usuario, redirigir según el rol del usuario
        const user = authService.getCurrentUser();
        if (user) {
            switch (user.role) {
                case 'admin':
                    router.navigate('/admin');
                    break;
                case 'cashier':
                    router.navigate('/cashier');
                    break;
                case 'payout_agent':
                    router.navigate('/payout');
                    break;
                default:
                    router.navigate('/login'); // En caso de rol desconocido
            }
        } else {
            router.navigate('/login');
        }
    }
}

// Ejecutar la inicialización cuando el DOM esté cargado
document.addEventListener('DOMContentLoaded', initializeApp);
